var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-card',{staticClass:"lead-collector-section",attrs:{"size":"large"}},[_c('LeadCollectorForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }